import React from 'react';
import Image from "../image";
import { createComponent } from "../../../wayin-react";
import assetRefService from "../../../util/asset";
var InstagramVideo = createComponent({
  displayName: 'InstagramVideo',
  lifecycles: {
    // load instagram scripts
    componentDidMount: function componentDidMount() {
      // if the script is not downloaded, we download it and it will automatically process to generate an iframe
      if (!document.getElementById('react-instagram-embed-script')) {
        var s = document.createElement('script');
        s.async = s.defer = true;
        s.src = '//www.instagram.com/embed.js';
        s.id = 'react-instagram-embed-script';
        document.body.appendChild(s);
      } // if instagram object is already initiated (on the next mount), we have to process it manually


      if (window.instgrm) {
        window.instgrm.Embeds.process();
      }
    }
  },
  render: function render(_ref) {
    var src = _ref.src,
        id = _ref.id,
        thumbnailAssetRef = _ref.thumbnailAssetRef;

    var _src = id ? "//www.instagram.com/p/" + id : src;

    var asset = assetRefService.deserialize(thumbnailAssetRef);
    return /*#__PURE__*/React.createElement("div", {
      className: "ck instagram-video"
    }, /*#__PURE__*/React.createElement("blockquote", {
      className: "instagram-video__media instagram-media",
      "data-instgrm-permalink": _src,
      "data-instgrm-version": "14"
    }, thumbnailAssetRef ? /*#__PURE__*/React.createElement("div", {
      className: "instagram-video__thumbnail"
    }, /*#__PURE__*/React.createElement(Image, {
      src: assetRefService.cleanUrl(asset.location)
    })) : null));
  }
});
export default InstagramVideo;
//# sourceMappingURL=instagram-video.js.map